module.exports = __webpack_public_path__ + "img/right_btn.744af489.png";